import { render, staticRenderFns } from "./PanelCandidatesTab.vue?vue&type=template&id=3206773c&scoped=true"
import script from "./PanelCandidatesTab.vue?vue&type=script&lang=js"
export * from "./PanelCandidatesTab.vue?vue&type=script&lang=js"
import style0 from "./PanelCandidatesTab.vue?vue&type=style&index=0&id=3206773c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3206773c",
  null
  
)

export default component.exports